<template functional>
  <div
    class="flex items-center justify-center rounded-full"
    :class="data.staticClass"
    :style="{ height: `${props.size}px`, width: `${props.size}px` }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 50,
    },
  },
};
</script>

<style scoped>

</style>
